import { render, staticRenderFns } from "./wxLink.vue?vue&type=template&id=051c8804&scoped=true"
import script from "./wxLink.vue?vue&type=script&lang=js"
export * from "./wxLink.vue?vue&type=script&lang=js"
import style0 from "./wxLink.vue?vue&type=style&index=0&id=051c8804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c8804",
  null
  
)

export default component.exports